// 💥 請注意, 在修改這個檔案的時候，也需要一起同步其他 WL 的客製化 service worker 的檔案內容

import { precacheAndRoute, cleanupOutdatedCaches } from 'workbox-precaching'

const cacheVersion = 'v4'
const cacheName = `static-resources-${cacheVersion}`

// 清理舊的 cache
cleanupOutdatedCaches()

// 檔案沒有  self.__WB_MANIFEST 會 build 不過
const filteredManifest = self.__WB_MANIFEST.filter(() => false)
precacheAndRoute(filteredManifest)

self.addEventListener('activate', event => {
  const cacheWhitelist = [cacheName]

  event.waitUntil(
    caches
      .keys()
      .then(cacheNames => {
        return Promise.all(
          cacheNames.map(cacheName => {
            if (
              !cacheWhitelist.includes(cacheName) &&
              !cacheName.startsWith('workbox-precache')
            ) {
              return caches.delete(cacheName)
            }
          })
        )
      })
      .then(() => {
        return self.clients.claim()
      })
  )
})

self.addEventListener('install', () => {
  self.skipWaiting()
})
